export const VERIFIED_BADGE_BIT = 2048;
export const VERIFIED_SERVER_FLAG = 2;
export const BANNED_USER_FLAG = 4;

export type IdfProfileBadgeDefinition = {
  id: string;
  bit: number;
  name: string;
  description: string;
  icon: string;
  colour: string;
  built_in: boolean;
};

export type IdfAdminUser = {
  id: string;
  username: string;
  discriminator: string;
  display_name?: string;
  badges: number;
  flags: number;
  privileged: boolean;
  banned: boolean;
};

export type IdfCustomBadgeDraft = {
  name: string;
  description?: string;
  icon: string;
  colour: string;
};

export type IdfAdminUserUpdate = {
  discriminator?: string;
  badge?: { bit: number; active: boolean };
  verified?: boolean;
  banned?: boolean;
};

export type IdfAdminServer = {
  id: string;
  name: string;
  owner: string;
  flags: number;
  verified: boolean;
};

export type IdfAdminServerUpdate = {
  verified: boolean;
};

export function applyBadgeAssignment(
  current: number,
  bit: number,
  active: boolean,
): number {
  return active ? current | bit : current & ~bit;
}

export function applyServerVerification(
  current: number,
  verified: boolean,
): number {
  return verified
    ? current | VERIFIED_SERVER_FLAG
    : current & ~VERIFIED_SERVER_FLAG;
}

export function canShowAdministration(privileged?: boolean): boolean {
  return privileged === true;
}

export function validateDiscriminator(value: string): string | undefined {
  const normalised = value.trim();
  return /^\d{4}$/.test(normalised) ? normalised : undefined;
}

export function validateCustomBadge(
  draft: IdfCustomBadgeDraft,
): Required<IdfCustomBadgeDraft> | undefined {
  const name = draft.name.trim();
  const description = draft.description?.trim() ?? "";
  const icon = draft.icon.trim();
  const colour = draft.colour.trim().toUpperCase();
  if (!name || [...name].length > 32) return;
  if ([...description].length > 160) return;
  if (!icon || [...icon].length > 4) return;
  if (!/^#[0-9A-F]{6}$/.test(colour)) return;
  return { name, description, icon, colour };
}

export function isBanned(flags: number): boolean {
  return (flags & BANNED_USER_FLAG) !== 0;
}
